export class FootNoteDetail {
  constructor(code, description) {
    this.code = code;
    this.description = description;
  }
  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new FootNoteDetail(input.code, input.description)
    }
    return new FootNoteDetail();
  }
  static fromApiArray(input) {
    if (Array.isArray(input)) {
      return input.map(item => FootNoteDetail.fromApiObject(item));
    }
    if (input && typeof (input) === "object") {
      return [FootNoteDetail.fromApiObject(input)];
    }
    return [];
  }

  genHtml() {
    
  }
}